import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityApiVolume } from '@api/data-security';

export const getCoreDataSecurityApiVolumeSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityApiVolume',
	receive: true,
	request: true,
	requestHandler: getDataSecurityApiVolume,
	retainDataOnRequest: true
});
